!!document.getElementById("circular-widget") &&
    (function () {
        var sc = document.createElement('script');
        sc.type = 'text/javascript';
        sc.async = true;
        sc.src = '//c.go-fet.ch/a/embed.js';
        sc.charset = 'utf-8';

        var attr = document.createAttribute("data-host");
        attr.value = "marketwatch.com";

        sc.setAttributeNode(attr);

        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(sc, s);
    }());
